import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

// Landing page components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import HeroPreview from "./components/HeroPreview";
import ValueSection from "./components/ValueSection";
import ServicesSection from "./components/ServicesSection";
import PortfolioSection from "./components/PortfolioSection";
import DiscretionSection from "./components/DiscretionSection";
import PricingSection from "./components/PricingSection";
import TargetAudienceSection from "./components/TargetAudienceSection";
import BookingSection from "./components/BookingSection";
import Footer from "./components/Footer";

// Admin
import AdminPage from "./components/AdminPage";

// Legal
import ImpressumPage from "./components/ImpressumPage";
import DatenschutzPage from "./components/DatenschutzPage";
import AGBPage from "./components/AGBPage";

const LandingPage = () => (
  <div className="min-h-screen bg-[#0a0a0a]">
    <Header />
    <main>
      <HeroSection />
      <HeroPreview />
      <ValueSection />
      <ServicesSection />
      <PortfolioSection />
      <DiscretionSection />
      <PricingSection />
      <TargetAudienceSection />
      <BookingSection />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/agb" element={<AGBPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
